import { MapPin, WhatsappLogo, Clock, Lightning } from "@phosphor-icons/react";

const features = [
  {
    icon: Lightning,
    title: "Entrega na Hora",
    description: "Atendemos avulsos no local com entrega imediata",
  },
  {
    icon: Clock,
    title: "Horário Flexível",
    description: "Agende seu horário pelo WhatsApp",
  },
  {
    icon: MapPin,
    title: "Atendimento Local",
    description: "Vamos até você para entregas avulsas",
  },
];

const Contact = () => {
  return (
    <section 
      id="contato" 
      className="py-24 px-6 bg-[#03030A]"
      data-testid="contact-section"
    >
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#00E5FF] uppercase tracking-[0.2em] text-sm font-semibold mb-4 block">
            Entre em Contato
          </span>
          <h2 className="font-outfit text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">
            Vamos <span className="gradient-text">Criar Juntos</span>
          </h2>
          <p className="text-[#A0AEC0] text-lg max-w-2xl mx-auto">
            Tem uma ideia? Fale conosco pelo WhatsApp e transforme sua visão em realidade
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-8 rounded-2xl bg-[#0C0D14] border border-white/5 text-center hover:border-[#00E5FF]/30 transition-all"
              data-testid={`contact-feature-${index}`}
            >
              <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-gradient-to-br from-[#00E5FF]/10 to-[#D500F9]/10 flex items-center justify-center">
                <feature.icon weight="fill" className="text-[#00E5FF]" size={32} />
              </div>
              <h3 className="font-outfit text-xl font-bold text-white mb-3">
                {feature.title}
              </h3>
              <p className="text-[#A0AEC0]">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA Card */}
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-[#0C0D14] to-[#0C0D14] border border-white/10 p-8 md:p-12">
          {/* Glow effects */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-[#00E5FF]/10 blur-[100px] rounded-full"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#D500F9]/10 blur-[100px] rounded-full"></div>
          
          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-8">
            <div className="text-center md:text-left">
              <h3 className="font-outfit text-2xl md:text-3xl font-bold text-white mb-3">
                Pronto para começar?
              </h3>
              <p className="text-[#A0AEC0] text-lg">
                Entre em contato agora e faça seu orçamento sem compromisso
              </p>
            </div>
            <a
              href="https://wa.me/5527981761251?text=Olá! Gostaria de fazer um orçamento."
              target="_blank"
              rel="noopener noreferrer"
              className="flex-shrink-0 inline-flex items-center gap-3 bg-[#25D366] text-white px-8 py-4 rounded-full font-bold text-lg hover:shadow-[0_0_30px_rgba(37,211,102,0.4)] transition-all hover:scale-105"
              data-testid="contact-whatsapp-cta"
            >
              <WhatsappLogo weight="fill" size={28} />
              <span>Chamar no WhatsApp</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
